import { h1, h2, p, strong, hr, wrapHTML, parseMarkdown } from './htmlUtils';

/**
 * Format Press Release data as HTML (matches PressReleaseRenderer.tsx)
 */
export const formatPressReleaseHTML = (data: any): string => {
  if (!data || !data.headline) {
    return wrapHTML(p('No press release content available'));
  }

  const sections: string[] = [];

  // Headline
  sections.push(h1(data.headline));

  // Subheadline (optional)
  if (data.subheadline) {
    sections.push(h2(data.subheadline));
  }

  // Dateline
  if (data.dateline) {
    sections.push(p(strong(data.dateline)));
  }

  // Lead Paragraph
  if (data.lead_paragraph) {
    sections.push(p(parseMarkdown(data.lead_paragraph).replace(/\n/g, '<br/>')));
  }

  // Body Paragraphs
  if (data.body_paragraphs) {
    sections.push(p(parseMarkdown(data.body_paragraphs).replace(/\n/g, '<br/>')));
  }

  // Boilerplate
  if (data.boilerplate) {
    sections.push(hr());
    sections.push(p(parseMarkdown(data.boilerplate).replace(/\n/g, '<br/>')));
  }

  // Media Contact
  if (data.media_contact) {
    sections.push(hr());
    sections.push(p(strong('Media Contact:')));
    sections.push(p(`${data.media_contact.name}<br/>${data.media_contact.title}<br/>${data.media_contact.email}<br/>${data.media_contact.phone}`));
  }

  return wrapHTML(sections.join(''));
};

